export default () => {
  const titleWidth = () => ['w-20', 'w-28', 'w-24'][Math.floor(Math.random() * 3)];

  const priceWidth = () => ['w-6', 'w-8'][Math.floor(Math.random() * 2)];

  return (
    <div class="product-item animate-pulse @container">
      <div class="aspect-h-3 aspect-w-2">
        <div class="bg-gray-200" />
      </div>

      <div class="px-4 pt-4" data-content="">
        <div class="mb-3 flex-wrap justify-between gap-2 flex">
          <p class="w-full @xs:w-auto">
            <span class={`${titleWidth()} h-3.5 rounded-full bg-gray-200 block`} />
          </p>

          <p class="w-full @xs:w-auto">
            <span class={`${priceWidth()} h-3.5 rounded-full bg-gray-200 block`} />
          </p>
        </div>

        <div class="flex-wrap items-start justify-between gap-3 flex @2xs:flex-nowrap">
          <div class="h-[1em] w-full items-center gap-2 flex @2xs:w-auto">
            <button class="swatch bg-gray-200" />
            <button class="swatch bg-gray-200" />
            <button class="swatch bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
};
